import { useAuth } from '../auth/AuthContext';

interface LoginPageProps {
  /** Shown when the user is signed in via Entra ID but not on the access list. */
  noAccessHint?: { email: string; detail: string } | null;
}

export function LoginPage({ noAccessHint }: LoginPageProps) {
  const auth = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-md bg-white rounded-xl shadow-card p-6 space-y-5">
        <div>
          <h1 className="text-xl font-semibold text-slate-900">
            Intake Forms Assistant
          </h1>
          <p className="mt-1 text-sm text-slate-600">
            Sign in with your Danone account to continue.
          </p>
        </div>

        {noAccessHint ? (
          <div
            role="alert"
            className="text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-md px-3 py-2 space-y-1"
          >
            <div className="font-medium">No access granted</div>
            <div>
              <span className="font-mono break-all">{noAccessHint.email}</span>{' '}
              isn&apos;t on the reviewer list yet.
            </div>
            <div className="text-rose-600">{noAccessHint.detail}</div>
          </div>
        ) : null}

        <button
          type="button"
          className="btn-primary w-full"
          onClick={() => auth.login()}
          disabled={auth.isLoading}
        >
          {auth.isLoading ? 'Loading…' : 'Sign in with Microsoft'}
        </button>

        {noAccessHint ? (
          <button
            type="button"
            className="text-sm text-slate-500 underline w-full text-center"
            onClick={() => auth.logout()}
          >
            Sign out and try a different account
          </button>
        ) : null}
      </div>
    </div>
  );
}
